export default function FooterBrandColumn() {
  return (
    <div>
      <div className="mb-5">
        <img
          src="/mcx-logo-full-white-240.png"
          alt="MobileCoreX"
          className="h-8 w-auto object-contain"
        />
      </div>
      <p className="text-sm leading-relaxed mb-5" style={{ color: '#64748B' }}>
        NCC-licensed Mobile Virtual Network Enabler. Institutional-grade MVNO infrastructure for Nigeria.
      </p>
      <address className="not-italic text-sm space-y-1.5" style={{ color: '#64748B' }}>
        <p>Plot 657 Atiku Abubakar Way</p>
        <p>Idu Industrial Area, Abuja, FCT</p>
        <p className="mt-3">RC No. 6977362 &nbsp;&middot;&nbsp; Est. 2023</p>
        <p>+234 (0) 209 623 2186</p>
        <p>sales@mobilecorex.ng</p>
      </address>
    </div>
  );
}
